export const SkinDataQuery = `
    query querySkinData {
        skinClinics(first: 1000) {
            nodes {
                id
                title
                skinLocationCategories(first: 1000) {
                    nodes {
                        name
                    }
                }
                acfData {
                    image {
                        mediaItemUrl
                    }
                    logo {
                        mediaItemUrl
                    }
                    address {
                        latitude
                        longitude
                        streetAddress
                        streetNumber
                        streetName
                        postCode
                    }
                    buttons {
                        title
                        link
                    }
                    overrideStreetAddress
                    website
                    telephone
                }
            }
        }
        skinLocationCategories(first: 1000) {
            nodes {
                name
            }
        }
    }
`